import { RootState } from "../store";

export const searchResultSelector = (state: RootState) =>
  state.domain.searchResult;

export const domainSearchingSelector = (state: RootState) =>
  state.domain.searchingDomain;

export const gettingAlternativeDomainExtensionsSelector = (state: RootState) =>
  state.domain.gettingAlternativeDomainExtensions;

export const alternativeDomainExtensionsGottenForDomainSelector = (
  state: RootState,
) => state.domain.alternativeDomainExtensionsGottenForDomain;

export const alternativeDomainExtensionsSelector = (state: RootState) =>
  state.domain.alternativeDomainExtensions;

export const expiredDomainsSelector = (state: RootState) =>
  state.domain.expiredDomains;

export const expiredDomainsTotalSelector = (state: RootState) =>
  state.domain.expiredDomainsTotal;

export const expiredDomainsPageSelector = (state: RootState) =>
  state.domain.expiredDomainsPage;

export const expiredDomainsPageSizeSelector = (state: RootState) =>
  state.domain.expiredDomainsPageSize;

export const gettingExpiredDomainsSelector = (state: RootState) =>
  state.domain.gettingExpiredDomains;

export const getExpiredDomainsErrorSelector = (state: RootState) =>
  state.domain.getExpiredDomainsError;

export const availableDomainsSelector = (state: RootState) =>
  state.domain.availableDomains;

export const availableDomainsTotalSelector = (state: RootState) =>
  state.domain.availableDomainsTotal;

export const availableDomainsPageSelector = (state: RootState) =>
  state.domain.availableDomainsPage;

export const availableDomainsPageSizeSelector = (state: RootState) =>
  state.domain.availableDomainsPageSize;

export const gettingAvailableDomainsSelector = (state: RootState) =>
  state.domain.gettingAvailableDomains;

export const getAvailableDomainsErrorSelector = (state: RootState) =>
  state.domain.getAvailableDomainsError;

export const newDomainsSelector = (state: RootState) => state.domain.newDomains;

export const gettingNewDomainsSelector = (state: RootState) =>
  state.domain.gettingNewDomains;

export const getNewDomainsErrorSelector = (state: RootState) =>
  state.domain.getNewDomainsError;

export const resellersSelector = (state: RootState) => state.domain.resellers;

export const resellersFailedSelector = (state: RootState) =>
  state.domain.resellersFailed;

export const whoisSelector = (state: RootState) => state.domain.whois;

export const gettingWhoisSelector = (state: RootState) =>
  state.domain.gettingWhois;

export const domainDetailsSelector = (state: RootState) =>
  state.domain.domainDetails;

export const gettingDomainDetailsSelector = (state: RootState) =>
  state.domain.gettingDomainDetails;

export const getDomainDetailsErrorSelector = (state: RootState) =>
  state.domain.getDomainDetailsError;
